module.exports = __webpack_public_path__ + "static/media/times-solid.38a30e58.svg";